import type { RootState } from 'state';
import { Carrier } from '../constants/filtersKeys';

function isFetchingCarrierInProgress(state: RootState): boolean {
  const { fetching } = state.flightRoutes.filtersOptions;
  return fetching.indexOf(Carrier) !== -1;
}

export default isFetchingCarrierInProgress;
